import { UploadFile } from "antd/lib/upload/interface";

const extractFile = (uploadFile: UploadFile<any>) => {
    if (uploadFile.originFileObj && "name" in uploadFile.originFileObj) {
        return uploadFile.originFileObj;
    }
};

export default extractFile;
